import React from 'react'

import Bugsnag from '@bugsnag/js'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getErrorBoundary = () =>
  Bugsnag.getPlugin('react')?.createErrorBoundary(React) // https://github.com/bugsnag/bugsnag-js/blob/master/UPGRADING.md#types
